import { render } from "./VentasDirectas.vue?vue&type=template&id=6a35390f&scoped=true"
import script from "./VentasDirectas.vue?vue&type=script&lang=js"
export * from "./VentasDirectas.vue?vue&type=script&lang=js"

import "./VentasDirectas.vue?vue&type=style&index=0&id=6a35390f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a35390f"]])

export default __exports__